import React from 'react';
import useDetailsContext from './context';
import cn from 'classnames';
export default function TitleImage() {
    const { reverseGradient, title, titleImageUrl } = useDetailsContext();
    // const titleLogo = ''; // For future use
    if (!title || !titleImageUrl) {
        return null;
    }
    return (React.createElement("div", { className: cn('hero', { 'reverse-gradient': reverseGradient }) },
        React.createElement("div", { className: 'content book-title' },
            React.createElement("h1", { className: 'image-heading' },
                React.createElement("img", { className: 'title-image', src: titleImageUrl, alt: title, height: '130', width: '392' })))));
}
